module.exports = __webpack_public_path__ + "static/images/section2img.e043820.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/section2img.png
// module id = rU8d
// module chunks = 1